import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const RADIOLOGY_PATH = "/radiology/v1";

export const getRadiologyApi = async (params, options = {}) => await getRequest(`${RADIOLOGY_PATH}/list`, params, options);

export const getRadiologyByIdApi = async (params, options = {}) => await getRequest(`${RADIOLOGY_PATH}/request/${params?.id}`);

export const updateRadiologyApi = async (id, body) =>
  await putRequest(`${RADIOLOGY_PATH}/request/${id}`, body);

export const printRadiologyApi = async (id) =>
  await getRequest(`${RADIOLOGY_PATH}/report/${id}/pdf`, {}, {
    responseType: "arraybuffer",
    headers: { Accept: "application/pdf" },
  });

export const deleteRadiologyByIdApi = async (id) =>
  await deleteRequest(`${RADIOLOGY_PATH}/request/${id}`);
